import { createStyles, makeStyles } from "@material-ui/core/styles";
import { FilledTextFieldProps } from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React, { ReactElement } from "react";
import { Color } from "../theme";
import { PlainFunctionComponent } from "../types";

export interface HelperTextWithCounterProps {
    disabled?: boolean;
    helperText: FilledTextFieldProps["helperText"];
    length?: number;
    maxLength?: number;
}

export const HelperTextWithCounter: PlainFunctionComponent<HelperTextWithCounterProps> = ({ disabled, helperText, length, maxLength }): ReactElement => {
    const classes = useStyles();
    return (
        <>
            <Typography component="span" className={classes.leftHelperText} variant="body2">
                {helperText}
            </Typography>
            {maxLength && !disabled && (
                <Typography component="span" className={classes.rightHelperText} variant="body2">
                    {`${length ?? 0} / ${maxLength}`}
                </Typography>
            )}
        </>
    );
};

const useStyles = makeStyles(
    createStyles({
        leftHelperText: {
            flexGrow: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        rightHelperText: {
            color: Color.grey6,
            paddingLeft: "16px",
        },
    }),
);
